module.exports = __webpack_public_path__ + "static/media/JioHealthLogo.6a5a2e53.svg";